/* eslint quotes: "off" */
const es = {
  common: {
    ok: "¡OK!",
    oops: "¡Ups!",
    cancel: "Cancelar",
    back: "Atrás",
    email: "Correo electrónico",
    name: "Nombre",
    done: "Hecho",
    optional: "Opcional",
    next: "Siguiente",
    apply: "Aplicar",
    edit: "Editar",
    save: "Guardar",
    view: "Ver",
    error: "Error",
    loading: "Cargando...",
    submit: "Enviar",
    confirm: "Confirmar",
    discardChanges: "Descartar cambios",
    skip: "Saltar",
    yes: "Sí",
    no: "No",
  },
  forceUpdate: {
    title: "Actualización requerida",
    body: "Una nueva versión de la aplicación está disponible. Por favor, actualice para continuar usando la aplicación.",
    updateNow: "Actualizar ahora",
  },
  screenList: {
    readyForLaunch: "Lista de pantallas",
    exciting: "(toca un botón para navegar)",
  },
  loginScreen: {
    sentMagicLink: "¡Tienes correo!",
    inviteText: "te ha invitado a su crucero! Ingresa tu correo electrónico para unirte.",
    clickTheLink:
      "Te hemos enviado un enlace mágico de inicio de sesión. Toca el botón en tu correo electrónico para iniciar sesión automáticamente. Puede tardar unos minutos en llegar.",
    confirmationCodeInEmail:
      "Por favor, introduce el código de confirmación que recibiste en tu dirección de correo electrónico. Puede tardar unos minutos en llegar.",
    openMailApp: "Abrir aplicación de correo",
    resendEmail: "Reenviar correo",
    openEmailTitle: "Enlace de inicio de sesión enviado",
    openEmailError: "No se puede abrir el cliente de correo predeterminado.",
    resentLoginEmail: "¡Te hemos enviado otro enlace de inicio de sesión!",
    resending: "Reenviando...",
    loggingIn: "Iniciando sesión...",
    enterEmailError: "Por favor, introduce tu correo electrónico nuevamente",
    accountRemoval: "Eliminación de cuenta",
    accountRemovalMessage:
      "Hemos recibido la solicitud para eliminar tu cuenta. Puede tardar hasta 5 días hábiles en eliminar tus datos del sistema. Gracias por ser un cliente de Cruisen.",
    enterConfirmationCode: "Introduce el código de confirmación",
  },
  ahoyScreen: {
    ahoy: "¡Ahoy!",
    welcomeToCruisen: "Bienvenido a Cruisen, la forma más fácil de reservar un crucero – punto.",
  },
  onboardingScreen: {
    next: "Siguiente",
    getCruising: "¡A navegar!",
    createTrip: {
      title: "Crea tu viaje ideal",
      description:
        "Simplemente establece la región desde la que deseas navegar, elige uno o dos destinos y dinos cuándo te gustaría ir en tu crucero.",
    },
    rallyCrew: {
      title: "Reúne a tu tripulación",
      desciption:
        "Invita a tus amigos, familiares y compañeros. Añade y organiza a todos en sus respectivas habitaciones para el viaje.",
    },
    bookCruise: {
      title: "Reserva el crucero perfecto",
      description:
        "Explora una increíble selección de cruceros, perfectamente adaptados para ti y tu tripulación.",
    },
    navigator: {
      title: "¿Necesitas ayuda?",
      description:
        "Pregunta a Navigator, nuestro asistente impulsado por IA, cualquier cosa sobre tu futuro viaje, o incluso pide ayuda para encontrar el adecuado.",
    },
    loyaltyProgram: {
      title: "Gana puntos",
      description:
        "Obtén recompensas por crear un viaje, invitar a tus amigos y reservar con Cruisen.",
    },
  },
  registerScreen: {
    introduceYourself: "Preséntate",
    addPhoto: "Añadir una foto",
    changePhoto: "Cambiar foto",
    basicDetails: "Detalles básicos",
    firstName: "Nombre*",
    lastName: "Apellido*",
    ageGroup: "Grupo de edad*",
    phoneNumber: "Número de teléfono*",
    referralCode: "Código de referencia",
    emailAddress: "Dirección de correo electrónico",
    setSail: "Zarpar",
    chooseOption: "Elige una opción",
    takePhoto: "Tomar una foto",
    chooseFromLibrary: "Elegir de la biblioteca",
    errors: {
      failedToCreateUser:
        "¡Ups! Hubo un error al guardar tu perfil. Por favor, verifica tu conexión a internet e inténtalo de nuevo.",
      failedToUploadAvatar:
        "¡Ups! Hubo un error al subir tu avatar. Por favor, verifica tu conexión a internet e inténtalo de nuevo, o selecciona una foto diferente.",
      phoneNumberTitle: "Número de teléfono inválido",
      phoneNumberDescription:
        "Por favor, introduce un número de teléfono válido, como (123) 456-7890.",
    },
  },
  tripCreation: {
    title: "Crear un viaje",
    nameYourTrip: "Nombra tu viaje*",
    sailingFrom: "Navegando desde*",
    sailingTo: "Navegando hacia",
    travelDates: "Meses de salida*",
    createTrip: "Crear viaje",
    cruisesCount: "Cruceros encontrados: %{cruisesCount}",
    errors: {
      tripNameTitle: "Nombre del viaje demasiado largo",
      tripNameDescription: "El nombre del viaje no puede exceder los 25 caracteres",
    },
  },
  tripOverview: {
    departing: "Saliendo de %{locations}",
    to: "Navegar hacia %{locations}",
    locations: "%{amount} ubicaciones",
    cruises: "Cruceros",
    cruise: "Crucero",
    showAll: "Mostrar todo",
    crew: "Tripulación",
    invite: "Invitar",
    searchingCruises: "Buscando cruceros...",
    inviteTextMessage:
      '%{invitingUser} te ha invitado a unirte al viaje "%{tripName}" en la aplicación Cruisen',
    addRoom: "Añadir habitación",
    deleteRoom: "Eliminar habitación",
    bookRoom: "Reservar habitación",
    noCruisesFound: "No se encontraron cruceros",
    emptyCruisesListMessage:
      "No pudimos encontrar cruceros para estas fechas en este puerto. Intenta actualizar tu búsqueda.",
    changeSearchCriteria: "Por favor, cambia tus criterios de búsqueda",
    changeDates: "Cambiar fechas",
    changePort: "Cambiar puerto",
    roomOptions: "Opciones de habitación",
    addGuest: "Añadir un invitado",
    addProfileGuest: "Añadir perfil como invitado",
    pickProfile: "Elegir perfil",
    changeName: "Cambiar nombre",
    guestOptions: "Opciones de invitado",
    editGuestDetails: "Editar detalles del invitado",
    unassigned: "Sin asignar",
    unassignedActionText: "Unirse a la habitación para ser incluido en la reserva",
    joinRoom: "Unirse a la habitación",
    bringEveryone: "Trae a todos.",
    showMorePorts: "Mostrar %{amount} más puertos",
    sortBy: "Ordenar por",
    filters: "Filtros",
    tabTitles: {
      navigator: "Navigator",
      cruises: "Cruceros",
      crew: "Tripulación",
    },
    sortingLabels: {
      date: "Fecha",
      durationShortToLong: "Duración (más corta a más larga)",
      durationLongToShort: "Duración (más larga a más corta)",
      mostLiked: "Más gustados",
      priceByLowest: "Precio (de menor a mayor)",
      priceByHighest: "Precio (de mayor a menor)",
    },
  },
  cruiseFilteringModal: {
    reset: "Restablecer",
    ports: "Puertos",
    filterBy: "Filtrar por",
    noFiltersAvailable: "No hay filtros disponibles",
    price: "Precio",
    duration: "Duración",
    ships: "Barcos",
    shipLaunchYear: "Año de lanzamiento del barco",
    cruiseLines: "Líneas de cruceros",
    matchingCruisesCount: "%{amount} cruceros coincidentes",
    done: "Hecho",
    days: "%{amount} días",
  },
  addGuestModal: {
    pickProfile: "Elegir perfil",
    requiredFirstName: "Nombre*",
    requiredLastName: "Apellido*",
    requiredAgeGroup: "Grupo de edad*",
    email: "Correo electrónico",
    phoneNumber: "Número de teléfono",
    addGuest: "Añadir invitado",
    fillFirstAndLastNameError: "Necesitas llenar el grupo de edad, nombre y apellido del invitado",
  },
  editGuestModal: {
    editGuest: "Editar invitado",
  },
  guestOptionsModal: {
    editDetails: "Editar detalles",
    removeGuest: "Eliminar invitado",
  },
  changeRoomDetailsModal: {
    shortTitle: "Cambiar detalles",
    title: "Cambiar detalles de la habitación",
    roomNamePlaceholder: "Nombre de la habitación",
    submitButton: "Actualizar detalles",
    fillRoomName: "Necesitas llenar el nombre de la habitación",
  },
  addRoomModal: {
    title: "Crear habitación",
    requiredRoomName: "Nombre de la habitación*",
    cabinTypePreference: "Preferencia de tipo de cabina",
    cabinTypePlaceholder: "Sin preferencia",
    submitButton: "Añadir habitación",
  },
  deleteRoomModal: {
    title: "Eliminar habitación",
    warning: "Eliminar la habitación moverá a todos los invitados a sin asignar",
    submitButton: "Confirmar",
  },
  cruiseSuggestionCard: {
    perPerson: "/pp",
    noCabinsAvailable: "No hay cabinas disponibles",
    view: "Ver",
    tags: {
      lastOne: "Última",
    },
  },
  bookedCruiseCard: {
    from: "Desde",
    to: "Hasta",
    book: "Reservar",
    view: "Ver",
    ports: "%{amount} puertos",
    daysAndNights: "%{daysAmount} días, %{nightsAmount} noches",
    viewItinerary: "Ver itinerario",
  },
  roomCard: {
    deck: "Cubierta",
    room: "Habitación",
    leaveRoom: "Dejar habitación",
    join: "Unirse",
    addGuest: "Añadir invitado",
    changeName: "Cambiar nombre",
  },
  monthPicker: {
    dates: "Meses de salida",
    loadingDates: "Los meses de destino están surfeando las olas. ¡Espera!",
    datesUnavailable: "Algunas de las fechas seleccionadas no están disponibles",
    clearUnavailableDates: "Borrar meses no disponibles",
  },
  portPicker: {
    searchOrigin: "Buscar un origen",
    searchDestination: "Buscar un destino",
    originPorts: "Puertos de origen",
    destinationPorts: "Puertos de destino",
    portsLoading: "Los datos de los puertos están surfeando las olas. ¡Espera!",
    noResults: "Sin resultados",
    tryEditingYourSearch: "Intenta editar tu búsqueda",
    pickDeparturePort: "Para los puertos de destino, elige al menos un puerto de salida primero.",
  },
  errorAlert: {
    default: {
      title: "¡Ups!",
    },
    email: {
      title: "Dirección de correo electrónico inválida",
      content: "Por favor, inténtalo de nuevo.",
    },
  },
  errorScreen: {
    title: "¡Algo salió mal!",
    friendlySubtitle:
      "Esta es la pantalla que tus usuarios verán en producción cuando se produzca un error. Querrás personalizar este mensaje (ubicado en `app/i18n/en.ts`) y probablemente también el diseño (`app/screens/ErrorScreen`). Si deseas eliminar esto por completo, revisa `app/app.tsx` para el componente <ErrorBoundary>.",
    reset: "REINICIAR APP",
  },
  inviteModal: {
    heading: "Trae a todos",
    content:
      "¡Simplemente envía una invitación para agregar a otros a tu viaje! Gana %{tokenAmount} Cruisen Points por cada invitación, hasta %{invitationBonusLimit} personas.",
    button: "Enviar invitación",
    later: "Más tarde",
  },
  globalMenu: {
    trips: "Viajes",
    thirdOption: "Tercera opción",
    logOut: "Cerrar sesión",
    accountSettings: "Configuración de la cuenta",
    deleteAccount: {
      title: "Eliminar cuenta",
      warning:
        "¿Estás seguro de que deseas eliminar tu cuenta? Esto eliminará permanentemente toda la información personal y los datos de la cuenta y no se puede deshacer.",
    },
  },
  globalMenuScreen: {
    viewProfile: "Ver perfil",
    trips: "Viajes",
    loyaltyNumbers: "Números de lealtad",
    loyaltyTokens: "Cruisen Points",
    allProfiles: "Todos los perfiles",
    developerScreen: "Pantalla de desarrollador",
    inviteToTrip: "Invitar al viaje",
  },
  accountScreen: {
    title: "Tú",
    firstName: "Nombre",
    lastName: "Apellido",
    email: "Correo electrónico",
    phoneNumber: "Número de teléfono",
    pirateName: "Nombre pirata 🏴‍☠️",
    random: "Aleatorio",
    manageAccount: "Gestionar cuenta",
    logout: "Cerrar sesión",
    deleteAccount: "Eliminar cuenta",
    unsavedTitle: "Cambios no guardados",
    unsavedMessage: "¿Estás seguro de que deseas descartar todos los cambios de la cuenta?",
  },
  invitationScreen: {
    title: "¡te ha invitado a su viaje!",
    joinTrip: "Unirse al viaje",
    declineInvite: "Rechazar invitación",
    inviteMessage: "Has sido invitado a Cruisen, ¡regístrate ahora!",
    signUp: "Registrarse",
  },
  tripListScreen: {
    title: "Viajes",
    guests: "%{amount} invitados",
    noCruiseSelected: "Ningún crucero seleccionado",
    newTrip: "Nuevo viaje",
  },
  cruiseDetailsScreen: {
    decks: "Cubiertas",
    trip: "El viaje",
    ship: "El barco",
    day: "Día %{day} · %{date}",
    viewFullTrip: "Ver viaje completo",
    perPerson: "/pp",
    select: "Seleccionar",
    showMore: "Mostrar más",
    whatsIncluded: "Qué está incluido",
    cabins: "Cabinas",
    noCabinsAvailable: "No hay cabinas disponibles",
    startingFrom: "Desde",
    showDetails: "Mostrar detalles",
    cabinTypeDetails: "Detalles del tipo de cabina",
    cabinImageUnavailable: "Imagen de la cabina no disponible",
    errors: {
      failedToLoad:
        "¡Ups! Hubo un error al cargar los detalles del crucero. Por favor, verifica tu conexión a internet e inténtalo de nuevo.",
    },
  },
  roomLayout: {
    adult: "adulto",
    adults: "adultos",
    child: "niño",
    children: "niños",
  },
  tripDetails: {
    anytime: "En cualquier momento",
    anywhere: "En cualquier lugar",
    anyport: "Cualquier puerto",
    months: "meses",
    anyportIn: "Cualquier puerto en %{group}",
    anyportInLocations: "Cualquier puerto en %{amount} ubicaciones",
    anyportFrom: "Cualquier puerto desde %{group}",
    anyportFromLocations: "Cualquier puerto desde %{amount} ubicaciones",
    locations: "%{amount} ubicaciones",
  },
  imageError: {
    cabin: "La imagen de la cabina no está disponible",
    cruise: "La imagen del crucero no está disponible",
  },
  navigatorSystemMessageComponents: {
    createTripWelcomeOne:
      "Hola, %{userFirstName} 👋 ¡Bienvenido a Cruisen! Soy Navigator, tu asistente de IA dedicado. Estoy aquí para guiarte desde la reserva de tu crucero hasta el inicio de tu viaje.",
    createTripWelcomeTwo:
      "Si necesitas ayuda, no dudes en 'Preguntar a Navigator' para obtener consejos sobre cómo planificar tus vacaciones de ensueño.",
    joinTripWelcomeOne:
      "¡Hola %{userFirstName}! Bienvenido a bordo de la aventura de tu vida. Soy Navigator, tu asistente de IA dedicado. Estoy aquí para guiarte desde la reserva de tu crucero hasta el inicio de tu viaje.",
    joinTripWelcomeTwo:
      "Si necesitas ayuda, no dudes en 'Preguntar a Navigator' para obtener consejos sobre cómo planificar tus vacaciones de ensueño.",
    viewTutorial: "Ver tutorial",
    cruiseBooked: "Ver crucero reservado",
    cruiseResultsReady: "Sumérgete en los resultados del crucero 🏊‍♂️",
    cruiseBookedDates: "Fechas de navegación: ",
    viewCruise: "Ver crucero",
    viewCruises: "Ver cruceros",
    viewRooms: "Ver habitaciones",
    addGuests: "Añadir invitados",
    exploreMore: "Explorar más",
    userBookedCabin: "%{userFirstName} %{userLastNameInitial}. ha reservado su cabina! 🎉",
    bookNearby: "Reservar cerca",
    bookedDeparting: "Saliendo de %{port}",
    cabinNumber: "Cabina #%{cabinNo}",
    sailingTo: "Navegando hacia: ",
    departing: "Saliendo: ",
    dates: "Meses de salida: ",
    anyPort: "En cualquier lugar",
    multiplePorts: "Múltiples seleccionados",
    recommendedDeck: "Revisa las cabinas en %{deckName} para tu tripulación",
  },
  navigator: {
    name: "Navegador",
    askAQuestion: "Haz una pregunta",
    messageCrew: "Mensaje a la tripulación",
    message: "Mensaje",
    askNavigator: "Preguntar al Navegador",
    getHelp: {
      button: "Contactar a Cruisen",
      title: "Obtener ayuda",
      emailSubject: "Ayuda con el viaje: %{title} (#%{id})",
      contentStart:
        "Lamentamos que estés experimentando algunas dificultades. Por favor envíanos un correo electrónico a ",
      contentEnd:
        " para asistencia. Ten la seguridad de que responderemos durante el horario laboral dentro de 2 días hábiles.",
    },
    error:
      "Actualmente estamos experimentando algunos problemas de conectividad con el Navegador, por favor vuelve más tarde. ¡Gracias por tu paciencia!",
    you: "Tú",
  },
  tripEdition: {
    title: "Editar un viaje",
    edit: "Editar",
  },
  ageGroups: {
    infant: {
      label: "Infante",
      range: "(menor de 2)",
    },
    child: {
      label: "Niño",
      range: "(2-17)",
    },
    adult: {
      label: "Adulto",
      range: "(mayor de 18)",
    },
  },
  cabinTypes: {
    inside: "Interior",
    outside: "Exterior",
    balcony: "Balcón",
    suite: "Suite",
  },
  cabinBookingCard: {
    deck: "Cubierta %{deckNo}",
    cabin: "Camarote %{cabinNo}",
    change: "Cambiar",
    totalAmount: "Monto total",
    cabinTotal: "Total del camarote",
    checkingCabinAvailability: "Verificando disponibilidad del camarote",
    changeCabin: "Por favor cambia tu camarote para continuar",
    checkBookingDetailsAndTryAgain:
      "Por favor verifica los detalles de los pasajeros y el pago, e inténtalo de nuevo",
    booked: "Reservado",
    diningOptions: "Opciones de comedor",
    chooseDiningOption: "Elige opción de comedor",
  },
  cabinDetails: {
    roomDetails: "Detalles de la habitación",
    totalAmount: "Monto total",
  },
  shipDetails: {
    launched: "Lanzado",
    occupancy: "Ocupación",
  },
  cabinsFiltering: {
    filterCabins: "Filtrar camarotes",
    samePrice: "Todos los camarotes en la cubierta tienen el mismo precio: %{price}",
    cabinTypes: "Tipos de camarote",
    matchingCabins: "%{amount} camarotes coincidentes en esta cubierta",
    matchingDecks: "%{amount} cubiertas con camarotes adecuados",
  },
  deckSelection: {
    selectDeck: "Seleccionar una cubierta",
    from: "Desde",
    matchingDecks: "Cubiertas que coinciden con tus filtros",
    notMatchingDecks: "Cubiertas que no coinciden con tus filtros",
    soldOut: "Agotado",
  },
  cabinSelectionSummary: {
    cabins: "Camarotes",
    changeCabins: "Cambia los camarotes para continuar",
    checkingCabinAvailability: "Verificando disponibilidad del camarote",
    continueToPayment: "Continuar al pago",
    settingUpPayment: "Configurando tu pago...",
    fillPaymentDetails: "Se requieren detalles de pago",
    fillDiningOptions: "Se requiere opción de comedor",
    fillContactDetails: "Se requieren detalles de contacto",
    fillPassengersInfo: "Se requiere información del marinero",
    bookAndPay: "Reservar y Pagar",
    noOptionSelected: "Ninguna opción seleccionada",
    selectedPaymentMethod: "Método de pago seleccionado",
    paymentDetailsUppercased: "DETALLES DE PAGO",
  },
  cruiseBooking: {
    roomSelection: "Selección de habitación",
    cabinType: "Tipo de camarote",
    selectCabin: "Seleccionar camarote",
    cabin: "Camarote %{cabinNo}",
    room: "Habitación",
    summary: "Resumen",
    payment: "Pago",
    selected: "%{amount} seleccionado",
    decks: "Cubiertas",
    cabinBooked: "camarote reservado",
    cabinsBooked: "camarotes reservados",
    loadingCabinsError:
      "No pudimos cargar los camarotes para esta cubierta. Inténtalo de nuevo más tarde o elige una cubierta diferente.",
    whichGroupBooking: "¿Para qué grupos estás reservando?",
    bookCruise: "Reservar crucero",
    bookingLoading: "Reservando...",
    findingCabins: "Escaneando disponibilidad...",
    preparingCabins: "Preparando camarotes...",
    lookingForPerfectFit: "Por favor espera, esto podría tardar un poco",
    cabinsNoneFoundYet: "Aún no se han encontrado camarotes",
    cabinsFound: "%{amount} camarotes encontrados",
    noCabinsAvailable: "No hay camarotes disponibles para este crucero",
    backToCruises: "Volver a la lista de cruceros",
    noCabinsMatchFilters: "No hay camarotes que coincidan con tus filtros para esta cubierta",
    clearFilters: "Limpiar filtros",
    changeDeck: "Cambiar cubierta",
    deckImageError: "No pudimos cargar la imagen de la cubierta, por favor inténtalo más tarde.",
    goBackToCruiseDetails: "Ir a los detalles del crucero",
    loyaltyTokens: {
      useloyaltyTokens: "Usar Puntos Cruisen",
      availablePoints: "%{amount} disponibles",
      applyPoints: "Aplicar puntos",
      firstBookingInfo:
        "Puedes aplicar hasta %{loyaltyTokensBookingCap} Puntos Cruisen (%{bookingCap}% de %{cruisePrice} antes de impuestos y tarifas) en tu primera reserva.",
      tripSubtotal: "Subtotal del viaje",
      tax: "Impuestos y Tarifas",
      tripTotal: "Total del viaje",
      total: "Total",
      loyaltyTokens: "Puntos Cruisen",
      bookingEarnings: "Ganarás %{amount} Puntos Cruisen por esta reserva.",
    },
    errors: {
      unknown: "Fallo en la reserva. Por favor contacta al soporte",
      basketNotFound: "Fallo en la reserva. Por favor contacta al soporte",
      cabinUnavailable: "Camarote ya no disponible",
      roomHasBookedCabin: "La habitación ya tiene un camarote reservado",
    },
  },
  passengerDetailsModal: {
    title: "Título",
    mr: "Sr",
    ms: "Sra",
    mrs: "Sra",
    miss: "Srta",
    passengerDetails: "Información del marinero",
    passengerDetailsWithName: "Información del marinero de %{name}",
    primarySailorResidence: "Usar mi residencia",
    enterValidPostcode: "Por favor ingresa un código postal válido, como 12345",
  },
  bookingPassengers: {
    roomInfo: "%{roomName} | Camarote %{cabinNo}",
    addInfo: "Agregar",
    sailorInfo: "Información del marinero",
    contactDetailsUppercased: "DETALLES DE CONTACTO",
    fillContactDetails: "Completa los detalles de contacto",
  },
  creditCardForm: {
    fillDetails: "Detalles de Pago",
    holder: "Nombre del titular de la tarjeta",
    cardNumber: "Número de tarjeta",
    expiry: "Vencimiento",
    cvcCode: "CVC",
    editDetails: "Editar detalles",
    addDetails: "Agregar detalles",
    addCreditCardDetails: "Agregar detalles de tarjeta de crédito",
  },
  profileScreen: {
    profiles: "Perfiles",
    primary: "Primario",
    sailors: "marineros",
    nights: "noches",
    itineraryDetails: "Detalles del itinerario",
    roomType: "Tipo de habitación",
    primarySailor: "Marinero principal",
    personalInfoPermission: "Tu información personal solo se usará para fines de reserva.",
    countryPicker: {
      searchCountry: "Buscar un país",
      noCountryLeft: "No quedan países, por favor cambia tu búsqueda",
    },
    statePicker: {
      searchState: "Buscar un estado",
      noStateLeft: "No quedan estados, por favor cambia tu búsqueda",
      states: {
        al: { code: "AL", name: "Alabama" },
        ak: { code: "AK", name: "Alaska" },
        az: { code: "AZ", name: "Arizona" },
        ar: { code: "AR", name: "Arkansas" },
        ca: { code: "CA", name: "California" },
        co: { code: "CO", name: "Colorado" },
        ct: { code: "CT", name: "Connecticut" },
        de: { code: "DE", name: "Delaware" },
        dc: { code: "DC", name: "Distrito de Columbia" },
        fl: { code: "FL", name: "Florida" },
        ga: { code: "GA", name: "Georgia" },
        hi: { code: "HI", name: "Hawái" },
        id: { code: "ID", name: "Idaho" },
        il: { code: "IL", name: "Illinois" },
        in: { code: "IN", name: "Indiana" },
        ia: { code: "IA", name: "Iowa" },
        ks: { code: "KS", name: "Kansas" },
        ky: { code: "KY", name: "Kentucky" },
        la: { code: "LA", name: "Luisiana" },
        me: { code: "ME", name: "Maine" },
        md: { code: "MD", name: "Maryland" },
        ma: { code: "MA", name: "Massachusetts" },
        mi: { code: "MI", name: "Michigan" },
        mn: { code: "MN", name: "Minnesota" },
        ms: { code: "MS", name: "Misisipi" },
        mo: { code: "MO", name: "Misuri" },
        mt: { code: "MT", name: "Montana" },
        ne: { code: "NE", name: "Nebraska" },
        nv: { code: "NV", name: "Nevada" },
        nh: { code: "NH", name: "Nuevo Hampshire" },
        nj: { code: "NJ", name: "Nueva Jersey" },
        nm: { code: "NM", name: "Nuevo México" },
        ny: { code: "NY", name: "Nueva York" },
        nc: { code: "NC", name: "Carolina del Norte" },
        nd: { code: "ND", name: "Dakota del Norte" },
        oh: { code: "OH", name: "Ohio" },
        ok: { code: "OK", name: "Oklahoma" },
        or: { code: "OR", name: "Oregón" },
        pa: { code: "PA", name: "Pensilvania" },
        ri: { code: "RI", name: "Rhode Island" },
        sc: { code: "SC", name: "Carolina del Sur" },
        sd: { code: "SD", name: "Dakota del Sur" },
        tn: { code: "TN", name: "Tennessee" },
        tx: { code: "TX", name: "Texas" },
        ut: { code: "UT", name: "Utah" },
        vt: { code: "VT", name: "Vermont" },
        va: { code: "VA", name: "Virginia" },
        wa: { code: "WA", name: "Washington" },
        wv: { code: "WV", name: "Virginia Occidental" },
        wi: { code: "WI", name: "Wisconsin" },
        wy: { code: "WY", name: "Wyoming" },
      },
    },
    form: {
      passengerDetails: "Información personal",
      passengerResidence: "Residencia",
      firstName: "Nombre*",
      lastName: "Apellido*",
      dateOfBirth: "Fecha de nacimiento",
      nationality: "Nacionalidad",
      address: "Dirección",
      state: "Estado",
      postcode: "Código postal",
      country: "País",
      city: "Ciudad",
      submit: "Enviar",
    },
  },
  loyaltyProgram: {
    title: "Puntos Cruisen",
    totalAvailablePoints: "Total de puntos disponibles",
    pendingPoints: "Puntos pendientes",
    history: "Historial",
    infoModal: {
      title: "Información de Puntos Cruisen",
      earningTokens: "Ganando Puntos",
      referralBonus:
        "- Bono de Referencia: Cuando un usuario comparte su enlace de viaje, gana 2,500 tokens si el usuario invitado reserva su primer viaje.",
      bookingBonus:
        "- Bono de Reserva: Los usuarios ganan un porcentaje del costo de su viaje en tokens cuando reservan un camarote.",
      usingTokens: "Usando Puntos",
      paymentUsage:
        "- Pago: Los usuarios pueden usar tokens para pagar una parte de su viaje, con un límite en el porcentaje para la primera reserva.",
    },
    historyItem: {
      influencerInvitation: "Registro en Cruisen",
      userJoined: "Registro en Cruisen",
      userInvitation: "%{invitedUserFirstName} %{invitedUserLastNameInitial}. se unió a Cruisen",
      booking: "Reservando un camarote",
      manualBonus: "Bono de Cruisen",
    },
  },
  cabinTypesDescriptions: {
    cabinTypesOverview: "Descripción de Tipos de Camarote",
    inside: "Interior",
    insideDescription:
      "Los camarotes interiores son compactos y rentables, diseñados para la comodidad y la utilidad, ideales para aquellos que prefieren pasar sus días explorando las comodidades del barco. Estos camarotes proporcionan un refugio acogedor para descansar después de un día lleno de actividades.",
    outside: "Exterior",
    outsideDescription:
      "Los camarotes exteriores ofrecen el beneficio adicional de una ventana o portilla, trayendo luz natural y vistas del océano o destinos. Esta opción combina la comodidad de alojamientos estándar con el placer de una vista externa.",
    balcony: "Balcón",
    balconyDescription:
      "Los camarotes con balcón extienden tu espacio privado al aire libre, permitiendo vistas personales del mar y aire fresco desde la comodidad de tu habitación. Logran un equilibrio entre el lujo del espacio y el disfrute de tu propia área al aire libre.",
    suite: "Suite",
    suiteDescription:
      "Las suites son el pináculo del alojamiento en cruceros, ofreciendo amplios espacios de vida, comodidades mejoradas y, a menudo, acceso exclusivo a servicios especializados. Proporcionan un refugio opulento para aquellos que buscan el máximo confort y exclusividad en su viaje.",
  },
  emptyStateComponent: {
    generic: {
      heading: "Tan vacío... tan triste",
      content:
        "Aún no se han encontrado datos. Intenta hacer clic en el botón para actualizar o recargar la aplicación.",
      button: "Intentémoslo de nuevo",
    },
  },
  emails: {
    global: {
      emailSignature: "El Equipo de Cruisen",
      unsubscribe: "Darse de baja",
      footerQuote: "Navega, juntos. Cruisen",
      help: "¿Necesitas ayuda?",
      contact: "Contactar a Cruisen",
    },
    login: {
      subject: "Iniciar sesión en Cruisen",
      title: "¡Bienvenido a bordo!",
      body: "Recibimos una solicitud para iniciar sesión en Cruisen usando esta dirección de correo electrónico. Simplemente toca el botón de inicio de sesión en el dispositivo donde instalaste Cruisen para iniciar sesión en la aplicación. Si no solicitaste este enlace, puedes ignorar este correo electrónico de manera segura.",
      button: "Iniciar sesión",
      confirmationOce: "Código de confirmación",
    },
    booking: {
      subject: "Confirmación de reserva de Cruisen",
      title: "¡Tu crucero está confirmado!",
      yourCruisenBookingNumber: "Tu número de reserva de Cruisen es ",
      body: "Detalles de tu viaje",
      guestsTitle: "Detalles del marinero",
      cruisenBookingNumber: "Número de reserva de Cruisen",
      cruisenBookingCode: "Código de reserva de Cruisen",
      mailingAddress: "Dirección postal",
      bookingCruiseLineReservationCode: "Número de reserva de la línea de cruceros",
      cabinDetailsTitle: "Detalles del barco y camarote",
      cruiseLine: "Línea de cruceros",
      cruiseShip: "Barco de cruceros",
      cabinNo: "Número de camarote",
      deck: "Cubierta",
      diningArea: "Área de comedor",
      itineraryTitle: "Tu itinerario",
      paymentDetailsTitle: "Detalles de pago",
      nameOnCard: "Nombre en la tarjeta",
      lastFourOnCard: "Últimos 4 números en la tarjeta",
      cardType: "Tipo de tarjeta",
      expirationDate: "Fecha de vencimiento",
      total: "Total",
      button: "Acción",
      loyaltyTokens: "Puntos Cruisen",
      loyaltyTokensEarned: "Puntos Cruisen ganados",
      taxesAndFees: "Impuestos y Tarifas",
    },
    marketing: {
      subject: "Nuevas ofertas de Cruisen",
      title: "Reserva tus vacaciones hoy.",
      body: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec neque neque, sagittis et semper elementum.",
      button: "Reservar ahora",
    },
    serious: {
      subject: "",
      body: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec neque neque, sagittis et semper elementum, varius nec mauris.\nPellentesque laoreet lorem massa, vitae suscipit augue ultrices at. Duis mattis massa vitae ante sodales convallis. Pellentesque bibendum quis quam quis bibendum. Maecenas sodales neque in urna fringilla, ac semper dolor cursus.\n Nam finibus, elit vel pretium vulputate, massa mi eleifend velit, at volutpat nunc felis vel libero.\n",
    },
  },
  validation: {
    useOnlyEnglishLetters: "Solo se permiten letras en inglés",
  },
  notifications: {
    tripCabinsScanFinished: {
      title: "Escaneo de Cabinas del Viaje Finalizado",
      body: "Escaneo de cabinas completado para todas las salidas del crucero",
    },
    cruiseCabinsScanFinished: {
      title: "Escaneo de Cabinas del Crucero Finalizado",
      body: "%{cruiseSailingName} tiene %{cabinsAvailable} cabinas disponibles desde %{lowestPrice}",
    },
    tripRoomCreated: {
      title: "%{userFirstName} %{userLastNameInitial}. creó %{roomName}",
      body: "%{userFirstName} %{userLastNameInitial}. creó %{roomName}. ¡Siéntete libre de unirte!",
    },
    tripRoomRenamed: {
      title: "%{userFirstName} %{userLastNameInitial}. renombró %{oldRoomName} a %{newRoomName}.",
      body: "%{userFirstName} %{userLastNameInitial}. renombró %{oldRoomName} a %{newRoomName}.",
    },

    // Break
    userLikedTripSearchResult: {
      title:
        "%{userFirstName} %{userLastNameInitial}. le gusta un crucero %{title} que zarpa el %{date}.",
      body: "%{userFirstName} %{userLastNameInitial}. le gusta un crucero %{title} que zarpa el %{date}.",
    },
    collaboratorJoinedTrip: {
      title: "Una nueva persona se unió al viaje",
      body: "%{userFirstName} %{userLastNameInitial}. se unió a %{tripName}",
      secondaryBody:
        "Hola, %{userFirstName} 👋 ¡Bienvenido a Cruisen! Estoy aquí para ayudarte a reservar tu crucero de manera sencilla desde el principio hasta que zarpe.",
    },
    guestJoinedTripRoom: {
      title: "Un invitado se unió a la habitación del viaje",
      body: "%{guestFirstName} %{guestLastNameInitial}. se unió a %{roomName}",
    },
    guestLeavedTripRoom: {
      title: "Un invitado dejó la habitación del viaje",
      body: "%{guestFirstName} %{guestLastNameInitial}. dejó %{roomName}",
    },
  },
  errors: {
    tryAgainLater: "Por favor, inténtalo de nuevo más tarde o contacta al equipo de soporte.",
    rooms: "¡Ups! Actualmente estamos enfrentando problemas para obtener habitaciones.",
    trip: "¡Ups! Actualmente estamos enfrentando problemas para obtener el viaje.",
    tripData: "¡Ups! Actualmente estamos enfrentando problemas para obtener los datos del viaje.",
    userTrips: "¡Ups! Actualmente estamos enfrentando problemas para obtener tus viajes.",
    invitation: "¡Ups! Actualmente estamos enfrentando problemas con la invitación.",
  },
}

type DeepPartial<T> = T extends object
  ? {
      [P in keyof T]?: DeepPartial<T[P]>
    }
  : T

export default es
export type Translations = typeof es
export type PartialTranslations = DeepPartial<typeof es>
